import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "opModal" };
const _hoisted_2 = { class: "form-group" };
const _hoisted_3 = { class: "form-group" };
const _hoisted_4 = { class: "form-group" };
const _hoisted_5 = { class: "d-flex align-items-center mt-1" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = { class: "form-group" };
const _hoisted_8 = { class: "text-right" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    const _component_tiny_editor = _resolveComponent("tiny-editor");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Invio email", -1)),
        (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_2, [
                    _cache[5] || (_cache[5] = _createElementVNode("label", null, "Mittente", -1)),
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.sender) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.sender]
                    ])
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _cache[6] || (_cache[6] = _createElementVNode("label", null, "Email destinatario", -1)),
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.in_recipient) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.in_recipient]
                    ])
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _cache[7] || (_cache[7] = _createElementVNode("label", null, "Oggetto", -1)),
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.subject) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.subject]
                    ])
                ]),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, [
                        _cache[8] || (_cache[8] = _createElementVNode("b", { class: "mr-1" }, "Carica testo template in lingua:", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (lang, i) => {
                            return (_openBlock(), _createElementBlock("button", {
                                type: "button",
                                class: _normalizeClass(["btn btn-small btn-link mr-1", { active: _ctx.selectedLanguage == lang }]),
                                key: i,
                                onClick: ($event) => (_ctx.loadTemplateInLanguage(lang))
                            }, _toDisplayString(lang), 11, _hoisted_6));
                        }), 128))
                    ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", null, "Testo", -1)),
                    _createVNode(_component_tiny_editor, {
                        modelValue: _ctx.finalText,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.finalText) = $event))
                    }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                    (_ctx.sending)
                        ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-green",
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => (_ctx.send && _ctx.send(...args)))
                        }, " Conferma invio mail "))
                ])
            ], 64))
    ]));
}
